import axios from 'axios';
import * as endpoints from './endpoints';

export function getAuditRecordsForSite(siteId, data) {
  return axios.get(`${endpoints.SITES}/${siteId}/history`, endpoints.headers(data));
}
